// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__KAVVD","checkmark":"Checkbox_checkmark__H3nN5","disabled":"Checkbox_disabled__h5VEk","checked":"Checkbox_checked__XxrrH","inline":"Checkbox_inline__AmGju"};